module.exports = __webpack_public_path__ + "img/helen-lomax.eb5bcbb0.jpg";